webpackJsonp([4,47],{

/***/ 1133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_chat_sideboxChat_vue__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_chat_sideboxChat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_chat_sideboxChat_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  watch: {
    toogleRssFeedSchedule: function toogleRssFeedSchedule(val) {
      this.$firebase.database().ref('allowRssFeedSchedule').set(val);
    }
  },
  computed: {
    posts: function posts() {
      return this.$store.getters.fetchFeeds;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    },
    feeds: function feeds() {
      var _this = this;

      if (this.currentStatus || this.currentStatus === 0 || this.dateRange !== 0) {
        var dateAfter = __WEBPACK_IMPORTED_MODULE_0_moment___default()().clone().subtract(this.dateRange, 'days').startOf('day');
        return this.posts.filter(function (post) {
          if (_this.currentStatus) {
            return post.approvalStatus === _this.currentStatus;
          }

          if (_this.dateRange !== 0) {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(post.posteddate).isAfter(dateAfter);
          }
        }).sort(function (d1, d2) {
          return new Date(d2.submitdate).getTime() - new Date(d1.submitdate).getTime();
        });
      } else {
        return this.posts.sort(function (d1, d2) {
          return new Date(d2.posteddate).getTime() - new Date(d1.posteddate).getTime();
        });
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    this.$store.dispatch('fetchAllPosts');
    this.$firebase.database().ref('allowRssFeedSchedule').once('value', function (snapshot) {
      if (snapshot.exists()) {
        _this2.toogleRssFeedSchedule = snapshot.val() ? true : false;
      }
    });
  },
  components: {
    SideViewChat: __WEBPACK_IMPORTED_MODULE_1__components_chat_sideboxChat_vue___default.a
  },
  data: function data() {
    return {
      selectedItem: {},
      emailDialog: false,
      toogleRssFeedSchedule: false,
      search: '',
      e1: '',
      currentPostId: '',
      pagination: {
        rowsPerPage: 15
      },
      notifyAllUsers: false,
      dialog: false,
      currentStatus: '',
      dateRange: 0,
      view_dialog: false,
      headers: [{
        text: 'Post Date',
        align: 'left',
        sortable: false,
        value: 'posteddate'
      }, {
        text: 'User',
        value: 'user',
        align: 'left',
        sortable: false
      }, {
        text: 'Company',
        value: 'companylegalname',
        align: 'left',
        sortable: false
      }, {
        text: 'Content',
        value: 'content',
        align: 'left',
        sortable: false
      }, {
        text: 'Status',
        value: 'status',
        align: 'left',
        sortable: false
      }, {
        text: 'Actions',
        value: 'actions',
        align: 'left',
        sortable: false
      }],
      status_filter: [{
        text: 'All',
        value: ''
      }, {
        text: 'Approved',
        value: 1
      }, {
        text: 'Pending',
        value: 0
      }, {
        text: 'Rejected',
        value: 2
      }],
      default_filter: [{
        text: 'All',
        value: 0
      }, {
        text: 'Last 24hrs',
        value: 1
      }, {
        text: 'Last 7 days',
        value: 7
      }, {
        text: 'Last 30 days',
        value: 30
      }],
      items: []
    };
  },
  methods: {
    itemRssFeedCategories: function itemRssFeedCategories(item) {
      var categories = [];

      if (item.type && item.type === 'rss') {
        categories = item.categories.map(function (category) {
          return "#".concat(category.replace(' ', '-')).toLowerCase();
        });
        return categories.join(' ');
      }
    },
    openChat: function openChat(uid) {
      this.contactUser(uid);
      this.contactUser(uid);
    },
    contactUser: function contactUser(uid) {
      window.$applozic.fn.applozic('loadTab', uid);
      document.getElementsByClassName('chatbutton ')[0].click();
    },
    changeStatus: function changeStatus(status, postId) {
      var payload = {
        type: 'posts',
        status: status,
        postId: postId
      };
      this.$store.dispatch('changeStatus', payload);
    },
    selectItem: function selectItem(item) {
      this.selectedItem = item;
    },
    emailUser: function emailUser(uid, approvalStatus) {
      var date = this.selectedItem.posteddate;

      if (approvalStatus === 1) {
        var notifyAllUsers = this.notifyAllUsers;
        this.$store.dispatch('sendMail', {
          uid: uid,
          action: 'post_approved',
          date: date
        });

        if (notifyAllUsers) {
          this.$store.dispatch('sendEmailToAllUsers', {
            postId: this.selectedItem.id,
            roles: [1, 4]
          });
        }
      } else if (approvalStatus === 2) {
        this.$store.dispatch('sendMail', {
          uid: uid,
          action: 'post_declined',
          date: date
        });
      }

      this.notifyAllUsers = false;
    },
    returnLogo: function returnLogo(logo) {
      if (!logo) {
        return '/static/images/default_company_logo.png';
      }

      return logo;
    },
    filterStatus: function filterStatus(status) {
      this.currentStatus = status;
    },
    assignId: function assignId(postId, type) {
      this.currentPostId = postId;
      this[type] = true;
    },
    deleteRow: function deleteRow() {
      var payload = {
        type: 'posts',
        postId: this.currentPostId
      };
      this.$store.dispatch('deletePost', payload);
      this.dialog = false;
    }
  }
};

/***/ }),

/***/ 1134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__company_company_info_vue__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__company_company_info_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__company_company_info_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__company_contract_info_vue__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__company_contract_info_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__company_contract_info_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__company_other_info_vue__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__company_other_info_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__company_other_info_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    companyInfo: __WEBPACK_IMPORTED_MODULE_3__company_company_info_vue___default.a,
    contractInfo: __WEBPACK_IMPORTED_MODULE_4__company_contract_info_vue___default.a,
    otherInfo: __WEBPACK_IMPORTED_MODULE_5__company_other_info_vue___default.a
  },
  mounted: function mounted() {
    this.fetchCompanySubmissions();
  },
  computed: {
    companies: function companies() {
      return this.$store.getters.getCompanySubmissions || [];
    },
    process: function process() {
      return this.$store.getters.getProcess;
    },
    allCompanies: function allCompanies() {
      var _this = this;

      if (this.currentStatus === true || this.currentStatus === false) {
        return this.companies.filter(function (company) {
          return company.verified === _this.currentStatus;
        }).sort(function (d1, d2) {
          return new Date(d2.submitdate).getTime() - new Date(d1.submitdate).getTime();
        });
      } else {
        return this.companies.filter(function (company) {
          return company.dunsnumber != null;
        }).sort(function (d1, d2) {
          return new Date(d2.submitdate).getTime() - new Date(d1.submitdate).getTime();
        });
      }
    }
  },
  data: function data() {
    return {
      loadingTable: false,
      selectedItem: {
        user: {}
      },
      search: '',
      e1: '',
      emailDialog: false,
      ex11: true,
      pagination: {},
      cmp1: [],
      activeDialog: false,
      dialog: false,
      currentStatus: 'all',
      currentEventId: '',
      dateRange: 0,
      view_dialog: false,
      info: [{
        name: 'Company Info',
        tabId: 'company_info'
      }, {
        name: 'Contracting Info',
        tabId: 'contracting_info'
      }, {
        name: 'Other Info',
        tabId: 'other_info'
      }],
      headers: [{
        text: 'Submit date',
        align: 'left',
        sortable: false,
        value: 'companyname'
      }, {
        text: 'Submitter',
        value: 'user',
        align: 'left',
        sortable: false
      }, {
        text: 'Company name',
        value: 'title',
        align: 'left',
        sortable: false
      }, {
        text: 'Company Description',
        align: 'left',
        sortable: false,
        value: 'posteddate'
      }, {
        text: 'Status',
        value: 'status',
        align: 'left',
        sortable: false
      }, {
        text: 'Actions',
        value: 'Actions',
        align: 'left',
        sortable: false
      }],
      status_filter: [{
        text: 'All',
        value: 'all'
      }, {
        text: 'Verified',
        value: true
      }, {
        text: 'Not Verified',
        value: false
      }],
      default_filter: [{
        text: 'Last 24hrs'
      }, {
        text: 'Last 7 days'
      }, {
        text: 'Last 30 days'
      }],
      items: []
    };
  },
  methods: {
    fetchCompanySubmissions: function fetchCompanySubmissions() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var snackbar;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this2.loadingTable = true;
                _context.next = 4;
                return _this2.$store.dispatch('fetchCompanySubmissions');

              case 4:
                _this2.loadingTable = false;
                _context.next = 12;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                snackbar = {
                  active: true,
                  text: 'An error occurred while fetching the company submissions'
                };

                _this2.$store.commit('triggerSnackbar', snackbar);

                _this2.loadingTable = false;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }))();
    },
    selectItem: function selectItem(item) {
      this.selectedItem = item;
    },
    changeStatus: function changeStatus(status, postId) {
      var _this3 = this;

      var api = 'https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2';
      var company = this.companies.filter(function (company) {
        return company.id === postId;
      });
      var postData = company[0];
      var payload = {
        type: 'companies',
        status: status,
        postId: postId
      };

      if (status) {
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete("".concat(api, "/").concat(postId)).then(function (response) {
          return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(api, postData).then(function (response) {
            payload.id = response.data['_id'];

            _this3.$store.dispatch('verifyCompany', payload);
          }).catch(function (error) {
            return error;
          });
        }).catch(function (error) {
          return error;
        });
      }

      return this.$store.dispatch('verifyCompany', payload);
    },
    emailUser: function emailUser(uid, verified, rejected) {
      if (rejected === true) {
        this.$store.dispatch('sendMail', {
          uid: uid,
          action: 'company_rejected'
        });
      } else if (verified === true) {
        this.$store.dispatch('sendMail', {
          uid: uid,
          action: 'company_approved'
        });
      }
    },
    approveSubmission: function approveSubmission(cid, uid) {
      this.$store.dispatch('approveCompanySubmission', {
        cid: cid,
        uid: uid
      });
    },
    rejectSubmission: function rejectSubmission(cid, uid) {
      this.$store.dispatch('rejectCompanySubmission', {
        cid: cid,
        uid: uid
      });
    },
    filterStatus: function filterStatus(status) {
      this.currentStatus = status;
    },
    deleteRow: function deleteRow() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.$store.dispatch('deleteCompanySubmision', {
                  cid: _this4.selectedItem.id,
                  uid: _this4.selectedItem.uid
                });

              case 2:
                _this4.dialog = false;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    assignId: function assignId(postId, type) {
      this.currentCompanyId = postId;
      this[type] = true;
    }
  }
};

/***/ }),

/***/ 1135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['props']
};

/***/ }),

/***/ 1136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['props']
};

/***/ }),

/***/ 1137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['props']
};

/***/ }),

/***/ 1138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  computed: {
    events: function events() {
      return this.$store.getters.fetchEvents;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    },
    allEvents: function allEvents() {
      var _this = this;

      if (this.currentStatus || this.currentStatus === 0 || this.dateRange !== 0) {
        var dateAfter = __WEBPACK_IMPORTED_MODULE_3_moment___default()().clone().subtract(this.dateRange, 'days').startOf('day');
        return this.events.filter(function (event) {
          if (_this.currentStatus) {
            return event.approvalStatus === _this.currentStatus;
          }

          if (_this.dateRange !== 0) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(event.submitdate).isAfter(dateAfter);
          }
        }).sort(function (d1, d2) {
          return new Date(d2.submitdate).getTime() - new Date(d1.submitdate).getTime();
        });
      } else {
        return this.events.sort(function (d1, d2) {
          return new Date(d2.submitdate).getTime() - new Date(d1.submitdate).getTime();
        });
      }
    }
  },
  data: function data() {
    return {
      emailDialog: false,
      selectedItem: {
        user: {}
      },
      search: '',
      e1: '',
      activeDialog: false,
      pagination: {
        rowsPerPage: 15
      },
      dialog: false,
      currentStatus: '',
      currentEventId: '',
      currentDate: '',
      dateRange: 0,
      view_dialog: false,
      headers: [{
        text: 'Submit Date',
        align: 'left',
        sortable: false,
        value: 'eventdate'
      }, {
        text: 'Submitter',
        value: 'user',
        align: 'left',
        sortable: false
      }, {
        text: 'Company',
        value: 'title',
        align: 'left',
        sortable: false
      }, {
        text: 'Event Title',
        value: 'title',
        align: 'left',
        sortable: false
      }, {
        text: 'Event Date',
        align: 'left',
        sortable: false,
        value: 'posteddate'
      }, {
        text: 'Status',
        value: 'status',
        align: 'left',
        sortable: false
      }, {
        text: 'Actions',
        value: 'action',
        align: 'left',
        sortable: false
      }],
      status_filter: [{
        text: 'All',
        value: ''
      }, {
        text: 'Approved',
        value: 1
      }, {
        text: 'Pending',
        value: 0
      }, {
        text: 'Rejected',
        value: 2
      }],
      default_filter: [{
        text: 'All',
        value: 0
      }, {
        text: 'Last 24hrs',
        value: 1
      }, {
        text: 'Last 7 days',
        value: 7
      }, {
        text: 'Last 30 days',
        value: 30
      }],
      items: []
    };
  },
  mounted: function mounted() {
    this.getEvents();
  },
  methods: {
    selectItem: function selectItem(item) {
      this.selectedItem = item;
    },
    emailUser: function emailUser(uid, approvalStatus) {
      var date = this.selectedItem.submitdate;

      if (approvalStatus === 1) {
        this.$store.dispatch('sendMail', {
          uid: uid,
          action: 'event_approved',
          date: date
        });
      } else if (approvalStatus === 2) {
        this.$store.dispatch('sendMail', {
          uid: uid,
          action: 'event_rejected',
          date: date
        });
      }
    },
    changeStatus: function changeStatus(status, postId) {
      var payload = {
        type: 'events',
        status: status,
        postId: postId
      };
      this.$store.dispatch('changeStatus', payload);
    },
    deleteRow: function deleteRow(selectedEvent) {
      var payload = {
        type: 'events',
        postId: this.currentEventId
      };
      this.$store.dispatch('deletePost', payload);
      this.dialog = false;
    },
    assignId: function assignId(postId, type) {
      this.currentEventId = postId;
      this[type] = true;
    },
    getEvents: function getEvents() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var DB, eventSnap, events, eventKeys, promises;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                DB = _this2.$firebase.database();
                _context2.next = 4;
                return DB.ref('events').once('value');

              case 4:
                eventSnap = _context2.sent;
                events = eventSnap.val();
                eventKeys = Object.keys(events);
                promises = eventKeys.map(function (key) {
                  var event = events[key];
                  return new Promise( /*#__PURE__*/function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                      var userSnap, user, companySnap, company;
                      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.prev = 0;
                              _context.next = 3;
                              return DB.ref("users/".concat(event.uid)).once('value');

                            case 3:
                              userSnap = _context.sent;
                              user = userSnap.val();
                              _context.next = 7;
                              return DB.ref("companies/".concat(user.cid)).once('value');

                            case 7:
                              companySnap = _context.sent;
                              company = companySnap.val() || {};
                              return _context.abrupt("return", resolve(_objectSpread(_objectSpread({}, event), {}, {
                                user: _objectSpread(_objectSpread({}, user), {}, {
                                  company: company
                                }),
                                avatar: user.avatar,
                                id: key,
                                eventKey: key
                              })));

                            case 12:
                              _context.prev = 12;
                              _context.t0 = _context["catch"](0);
                              reject(_context.t0);

                            case 15:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee, null, [[0, 12]]);
                    }));

                    return function (_x, _x2) {
                      return _ref.apply(this, arguments);
                    };
                  }());
                });
                _context2.next = 10;
                return Promise.all(promises);

              case 10:
                events = _context2.sent;

                _this2.$store.dispatch('fetchAllEvents', events);

                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](0);
                console.log('An error occurred while pulling the events', _context2.t0);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 14]]);
      }))();
    }
  }
};

/***/ }),

/***/ 1139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  computed: {
    events: function events() {
      return this.$store.getters.fetchGroupEvents;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    },
    allEvents: function allEvents() {
      var _this = this;

      if (this.currentStatus || this.currentStatus === 0 || this.dateRange !== 0) {
        var dateAfter = __WEBPACK_IMPORTED_MODULE_2_moment___default()().clone().subtract(this.dateRange, 'days').startOf('day');
        return this.events.filter(function (event) {
          if (_this.currentStatus) {
            return event.approvalStatus === _this.currentStatus;
          }

          if (_this.dateRange !== 0) {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(event.submitdate).isAfter(dateAfter);
          }
        }).sort(function (d1, d2) {
          return new Date(d2.submitdate).getTime() - new Date(d1.submitdate).getTime();
        });
      } else {
        return this.events.sort(function (d1, d2) {
          return new Date(d2.submitdate).getTime() - new Date(d1.submitdate).getTime();
        });
      }
    }
  },
  data: function data() {
    return {
      emailDialog: false,
      selectedItem: {
        user: {}
      },
      search: '',
      e1: '',
      pagination: {
        rowsPerPage: 15
      },
      dialog: false,
      currentStatus: '',
      currentEventId: '',
      currentDate: '',
      dateRange: 0,
      view_dialog: false,
      headers: [{
        text: 'Submit Date',
        align: 'left',
        sortable: false,
        value: 'eventdate'
      }, {
        text: 'Submitter',
        value: 'user',
        align: 'left',
        sortable: false
      }, {
        text: 'Event Title',
        value: 'title',
        align: 'left',
        sortable: false
      }, {
        text: 'Event Date',
        align: 'left',
        sortable: false,
        value: 'posteddate'
      }, {
        text: 'Status',
        value: 'status',
        align: 'left',
        sortable: false
      }, {
        text: 'Actions',
        value: 'action',
        align: 'left',
        sortable: false
      }],
      status_filter: [{
        text: 'All',
        value: ''
      }, {
        text: 'Approved',
        value: 1
      }, {
        text: 'Pending',
        value: 0
      }, {
        text: 'Rejected',
        value: 2
      }],
      default_filter: [{
        text: 'All',
        value: 0
      }, {
        text: 'Last 24hrs',
        value: 1
      }, {
        text: 'Last 7 days',
        value: 7
      }, {
        text: 'Last 30 days',
        value: 30
      }],
      items: []
    };
  },
  methods: {
    changeStatus: function changeStatus(status, groupId, itemId) {
      var stripedGroupId = groupId.replace('-', '');
      var payload = {
        type: 'groupevents',
        status: status,
        postId: "".concat(stripedGroupId, "/").concat(itemId)
      };
      console.log('payload', payload);
      this.$store.dispatch('changeStatus', payload);
    },
    selectItem: function selectItem(item) {
      this.selectedItem = item;
    },
    emailUser: function emailUser(uid, approvalStatus, groupId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var snapshot, group, date;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$firebase.database().ref('/groups/' + groupId).once('value');

              case 2:
                snapshot = _context.sent;
                group = snapshot.val();
                date = _this2.selectedItem.submitdate;

                if (approvalStatus === 1) {
                  _this2.$store.dispatch('sendMail', {
                    uid: uid,
                    action: 'group_event_approved',
                    date: date,
                    group: group.name
                  });
                } else if (approvalStatus === 2) {
                  _this2.$store.dispatch('sendMail', {
                    uid: uid,
                    action: 'group_event_rejected',
                    date: date,
                    group: group.name
                  });
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    deleteRow: function deleteRow() {
      var payload = {
        type: 'groupevents',
        postId: this.currentEventId
      };
      this.$store.dispatch('deletePost', payload);
      this.dialog = false;
    },
    assignId: function assignId(postId) {
      this.currentEventId = postId;
    }
  }
};

/***/ }),

/***/ 1140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  computed: {
    posts: function posts() {
      return this.$store.getters.fetchGroupPost;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === "Settings Saved";
    },
    process: function process() {
      return this.$store.getters.getProcess;
    },
    feeds: function feeds() {
      var _this = this;

      if (this.currentStatus || this.currentStatus === 0 || this.dateRange !== 0) {
        var dateAfter = __WEBPACK_IMPORTED_MODULE_0_moment___default()().clone().subtract(this.dateRange, "days").startOf("day");
        return this.posts.filter(function (post) {
          if (_this.currentStatus) {
            return post.approvalStatus === _this.currentStatus;
          }

          if (_this.dateRange !== 0) {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(post.posteddate).isAfter(dateAfter);
          }
        }).sort(function (d1, d2) {
          return new Date(d2.posteddate).getTime() - new Date(d1.posteddate).getTime();
        });
      }

      return this.posts.sort(function (d1, d2) {
        return new Date(d2.posteddate).getTime() - new Date(d1.posteddate).getTime();
      });
    }
  },
  data: function data() {
    return {
      search: "",
      e1: "",
      currentPostId: "",
      pagination: {
        rowsPerPage: 15
      },
      dialog: false,
      currentStatus: "",
      dateRange: 0,
      view_dialog: false,
      headers: [{
        text: "Post Date",
        align: "left",
        sortable: false,
        value: "posteddate"
      }, {
        text: "User",
        value: "user",
        align: "left",
        sortable: false
      }, {
        text: "Company",
        value: "companylegalname",
        align: "left",
        sortable: false
      }, {
        text: "Content",
        value: "content",
        align: "left",
        sortable: false
      }, {
        text: "Status",
        value: "status",
        align: "left",
        sortable: false
      }, {
        text: "Actions",
        value: "Actions",
        align: "left",
        sortable: false
      }],
      status_filter: [{
        text: "All",
        value: ""
      }, {
        text: "Approved",
        value: 1
      }, {
        text: "Pending",
        value: 0
      }, {
        text: "Rejected",
        value: 2
      }],
      default_filter: [{
        text: "All",
        value: 0
      }, {
        text: "Last 24hrs",
        value: 1
      }, {
        text: "Last 7 days",
        value: 7
      }, {
        text: "Last 30 days",
        value: 30
      }],
      items: []
    };
  },
  methods: {
    changeStatus: function changeStatus(status, postId) {
      var payload = {
        type: "groupposts",
        status: status,
        postId: postId
      };
      this.$store.dispatch("changeStatus", payload);
    },
    returnName: function returnName(key) {
      return key.firstname + " " + key.lastname;
    },
    filterStatus: function filterStatus(status) {
      this.currentStatus = status;
    },
    assignId: function assignId(postId) {
      this.currentPostId = postId;
    },
    deleteRow: function deleteRow() {
      var payload = {
        type: "groupposts",
        postId: this.currentPostId
      };
      this.$store.dispatch("deletePost", payload);
      this.dialog = false;
    }
  }
};

/***/ }),

/***/ 1150:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "#right[data-v-05d71da0]{float:right!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Request/events.vue"],"names":[],"mappings":"AACA,wBACE,qBAAwB,CACzB","file":"events.vue","sourcesContent":["\n#right[data-v-05d71da0] {\n  float: right !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1152:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "#right{float:right!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Request/groupevents.vue"],"names":[],"mappings":"AACA,OACE,qBAAwB,CACzB","file":"groupevents.vue","sourcesContent":["\n#right {\n  float: right !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1158:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "#right[data-v-5d887806]{float:right!important}#toggle_status[data-v-5d887806]{margin-top:10px}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Request/company.vue"],"names":[],"mappings":"AACA,wBACE,qBAAwB,CACzB,AACD,gCACE,eAAiB,CAClB","file":"company.vue","sourcesContent":["\n#right[data-v-5d887806] {\n  float: right !important;\n}\n#toggle_status[data-v-5d887806] {\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1159:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".rss-feed-switch label{font-weight:600!important;color:#212121!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Request/activity.vue"],"names":[],"mappings":"AACA,uBACE,0BAA4B,AAC5B,uBAA0B,CAC3B","file":"activity.vue","sourcesContent":["\n.rss-feed-switch label {\n  font-weight: 600 !important;\n  color: #212121 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1160:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".background-image[data-v-61ff64d6]{background-position-y:center;background-size:cover;background-repeat:no-repeat;top:0;left:0;right:0;height:260px;bottom:0}.card__title[data-v-61ff64d6]{padding-bottom:16px;padding-top:16px;padding-left:16px}.activity-search[data-v-61ff64d6]{margin-left:auto}.input-group .input-group__details[data-v-61ff64d6]{display:none}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Request/activity.vue"],"names":[],"mappings":"AACA,mCACE,6BAA8B,AAC9B,sBAAuB,AACvB,4BAA6B,AAC7B,MAAO,AACP,OAAQ,AACR,QAAS,AACT,aAAc,AACd,QAAU,CACX,AACD,8BACE,oBAAqB,AACrB,iBAAkB,AAClB,iBAAmB,CACpB,AACD,kCACE,gBAAkB,CACnB,AACD,oDACE,YAAc,CACf","file":"activity.vue","sourcesContent":["\n.background-image[data-v-61ff64d6] {\n  background-position-y: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 260px;\n  bottom: 0;\n}\n.card__title[data-v-61ff64d6] {\n  padding-bottom: 16px;\n  padding-top: 16px;\n  padding-left: 16px;\n}\n.activity-search[data-v-61ff64d6] {\n  margin-left: auto;\n}\n.input-group .input-group__details[data-v-61ff64d6] {\n  display: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1162:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"company_info.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1164:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"contract_info.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1166:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "#right[data-v-7f5de43b]{float:right!important}.background-image[data-v-7f5de43b]{background-position-y:center;background-size:cover;background-repeat:no-repeat;top:0;left:0;right:0;height:260px;bottom:0}.card__title[data-v-7f5de43b]{padding-bottom:30px;padding-top:0;padding-left:24px}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Request/groupposts.vue"],"names":[],"mappings":"AACA,wBACE,qBAAwB,CACzB,AACD,mCACE,6BAA8B,AAC9B,sBAAuB,AACvB,4BAA6B,AAC7B,MAAO,AACP,OAAQ,AACR,QAAS,AACT,aAAc,AACd,QAAU,CACX,AACD,8BACE,oBAAqB,AACrB,cAAe,AACf,iBAAmB,CACpB","file":"groupposts.vue","sourcesContent":["\n#right[data-v-7f5de43b] {\n  float: right !important;\n}\n.background-image[data-v-7f5de43b] {\n  background-position-y: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 260px;\n  bottom: 0;\n}\n.card__title[data-v-7f5de43b] {\n  padding-bottom: 30px;\n  padding-top: 0;\n  padding-left: 24px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1167:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"other_info.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1172:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1150);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("6cfd49b9", content, true, {});

/***/ }),

/***/ 1174:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1152);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("bf1e24b8", content, true, {});

/***/ }),

/***/ 1180:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1158);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("2f1653f3", content, true, {});

/***/ }),

/***/ 1181:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1159);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("7df6820f", content, true, {});

/***/ }),

/***/ 1182:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1160);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("23bf127d", content, true, {});

/***/ }),

/***/ 1184:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1162);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("497fc87c", content, true, {});

/***/ }),

/***/ 1186:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1164);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("089f3c69", content, true, {});

/***/ }),

/***/ 1188:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1166);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("05ea0e2d", content, true, {});

/***/ }),

/***/ 1189:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1167);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("2de0c9ad", content, true, {});

/***/ }),

/***/ 1204:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1181)
  __webpack_require__(1182)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1133),
  /* template */
  __webpack_require__(1227),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-61ff64d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1205:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1180)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1134),
  /* template */
  __webpack_require__(1226),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d887806",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1206:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1184)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1135),
  /* template */
  __webpack_require__(1229),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1207:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1186)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1136),
  /* template */
  __webpack_require__(1231),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1208:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1189)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1137),
  /* template */
  __webpack_require__(1235),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1209:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1172)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1138),
  /* template */
  __webpack_require__(1216),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05d71da0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1210:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1174)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1139),
  /* template */
  __webpack_require__(1218),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1211:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1188)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1140),
  /* template */
  __webpack_require__(1234),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7f5de43b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1216:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Events\n    ")])], 1), _vm._v(" "), _c('v-card-title', [_c('v-flex', {
    staticClass: "mr-4",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.status_filter,
      "label": "Status",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.currentStatus),
      callback: function($$v) {
        _vm.currentStatus = $$v
      },
      expression: "currentStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mr-4",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.default_filter,
      "label": "Date Range",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "xs3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.allEvents.length > 0) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.allEvents,
      "search": _vm.search,
      "pagination": _vm.pagination,
      "rows-per-page-items": [15, 25, 50, 100]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("actualDate")(props.item.submitdate)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "padding-right": "10px !important",
            "width": "164px"
          }
        }, [_c('div', {
          staticClass: "avatar",
          staticStyle: {
            "height": "24px",
            "width": "24px"
          }
        }, [(props.item.user.avatar) ? _c('img', {
          attrs: {
            "src": props.item.user.avatar,
            "alt": "logo"
          }
        }) : _vm._e(), _vm._v(" "), (!props.item.user.avatar) ? _c('img', {
          attrs: {
            "src": "https://randomuser.me/api/portraits/men/88.jpg",
            "alt": "logo"
          }
        }) : _vm._e()]), _vm._v("\n        " + _vm._s(props.item.user.firstname) + " " + _vm._s(props.item.user.lastname) + "\n      ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.user.company.companylegalname))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("sliceText")(props.item.title)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("actualDate")(props.item.eventdate)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("status")(props.item.approvalStatus)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-layout', {
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "green--text",
          attrs: {
            "slot": "activator",
            "disabled": props.item.approvalStatus === 1,
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.changeStatus(1, props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("done")])], 1), _vm._v(" "), _c('span', [_vm._v("Approve")])], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": "",
            "disabled": props.item.approvalStatus === 2
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.changeStatus(2, props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Reject")])], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.selectItem(props.item);
              _vm.assignId(props.item.id, 'activeDialog')
            }
          }
        }, [_c('v-icon', [_vm._v("remove_red_eye")])], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "icon": "",
            "medium": "",
            "disabled": !props.item.approvalStatus == 1 && props.item.approvalStatus !== 2
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.selectItem(props.item);
              _vm.assignId(props.item.id, 'emailDialog')
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "medium": ""
          }
        }, [_vm._v("email")])], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.selectItem(props.item);
              _vm.assignId(props.item.id, 'dialog')
            }
          }
        }, [_c('v-icon', [_vm._v("delete_forever")])], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + "\n    ")]
      }
    }], null, false, 3851595190)
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "width": "790px"
    },
    model: {
      value: (_vm.activeDialog),
      callback: function($$v) {
        _vm.activeDialog = $$v
      },
      expression: "activeDialog"
    }
  }, [_c('v-card', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "card": "",
      "color": "white",
      "prominent": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Event Details")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.activeDialog = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("clear")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("title")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedItem.title))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedItem.user.firstname) + " " + _vm._s(_vm.selectedItem.user.lastname))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedItem.eventdate))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Event date")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("watch_later")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedItem.starteventtime) + " " + _vm._s(_vm.selectedItem.endeventtime))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Event time")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedItem.location))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("event_note")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedItem.description))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("link")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('a', {
    attrs: {
      "href": _vm.selectedItem.link
    }
  }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedItem.link))])], 1)])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "absolute": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.emailDialog),
      callback: function($$v) {
        _vm.emailDialog = $$v
      },
      expression: "emailDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Confim Email")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to mail "), _c('b', [_vm._v(_vm._s(_vm.selectedItem.user.firstname))]), _vm._v("?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.emailDialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.emailDialog = false;
        _vm.emailUser(_vm.selectedItem.uid, _vm.selectedItem.approvalStatus)
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Really delete?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete "), _c('b', [_vm._v(_vm._s(_vm.selectedItem.user.firstname) + "'s")]), _vm._v(" event?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteRow()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1218:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-flex', {
    staticClass: "mr-4",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.status_filter,
      "label": "Status",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.currentStatus),
      callback: function($$v) {
        _vm.currentStatus = $$v
      },
      expression: "currentStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mr-4",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.default_filter,
      "label": "Date Range",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mr-4",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.allEvents.length > 0) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.allEvents,
      "search": _vm.search,
      "pagination": _vm.pagination,
      "rows-per-page-items": [15, 25, 50, 100]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("actualDate")(props.item.submitdate)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "avatar ml-2",
          staticStyle: {
            "height": "24px",
            "width": "24px"
          }
        }, [_c('img', {
          attrs: {
            "src": props.item.avatar,
            "alt": "logo"
          }
        })]), _vm._v("\n                \n                  " + _vm._s(props.item.firstname) + " " + _vm._s(props.item.lastname) + "\n                \n              ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("sliceText")(props.item.title)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("actualDate")(props.item.eventdate)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("status")(props.item.approvalStatus)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-layout', {
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "green--text",
          attrs: {
            "slot": "activator",
            "disabled": props.item.approvalStatus === 1,
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.changeStatus(1, ((props.item.groupId) + "/" + (props.item.id)))
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("done")])], 1), _vm._v(" "), _c('span', [_vm._v("Approve")])], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "slot": "activator",
            "disabled": props.item.approvalStatus === 2,
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.changeStatus(2, ((props.item.groupId) + "/" + (props.item.id)))
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-dialog', {
          attrs: {
            "lazy": "",
            "absolute": "",
            "width": "790px"
          },
          model: {
            value: (props.item.activeDialog),
            callback: function($$v) {
              _vm.$set(props.item, "activeDialog", $$v)
            },
            expression: "props.item.activeDialog"
          }
        }, [_c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('v-card', [_c('v-layout', {
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs12": "",
            "sm12": ""
          }
        }, [_c('v-card', [_c('v-toolbar', {
          attrs: {
            "card": "",
            "color": "white",
            "prominent": ""
          }
        }, [_c('v-toolbar-title', [_vm._v("Event Details")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "dark": "",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              props.item.activeDialog = false
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-list', {
          attrs: {
            "two-line": ""
          }
        }, [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("title")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(props.item.title) + " " + _vm._s(props.item.lastname))])], 1)], 1), _vm._v(" "), _c('v-divider', {
          attrs: {
            "inset": ""
          }
        }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(props.item.companylegalname) + " - ")])], 1)], 1), _vm._v(" "), _c('v-divider', {
          attrs: {
            "inset": ""
          }
        }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(props.item.eventdate))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Event date")])], 1)], 1), _vm._v(" "), _c('v-divider', {
          attrs: {
            "inset": ""
          }
        }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("watch_later")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(props.item.eventtime))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Event time")])], 1)], 1), _vm._v(" "), _c('v-divider', {
          attrs: {
            "inset": ""
          }
        }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(props.item.location))])], 1)], 1), _vm._v(" "), _c('v-divider', {
          attrs: {
            "inset": ""
          }
        }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("event_note")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(props.item.description))])], 1)], 1), _vm._v(" "), _c('v-divider', {
          attrs: {
            "inset": ""
          }
        }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("link")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('a', {
          attrs: {
            "href": props.item.link
          }
        }, [_c('v-list-tile-title', [_vm._v(_vm._s(props.item.link))])], 1)])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-dialog', {
          attrs: {
            "absolute": "",
            "max-width": "500px"
          },
          model: {
            value: (_vm.emailDialog),
            callback: function($$v) {
              _vm.emailDialog = $$v
            },
            expression: "emailDialog"
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": "",
            "medium": "",
            "disabled": !props.item.approvalStatus == 1 && props.item.approvalStatus !== 2
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.selectItem(props.item)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "medium": ""
          }
        }, [_vm._v("email")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
          staticClass: "headline"
        }, [_vm._v("Confim Email")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to mail user '" + _vm._s(_vm.selectedItem.firstname) + " " + _vm._s(_vm.selectedItem.lastname) + "'?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          staticClass: "blue--text darken-1",
          attrs: {
            "flat": "flat"
          },
          nativeOn: {
            "click": function($event) {
              _vm.emailDialog = false
            }
          }
        }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
          staticClass: "blue--text darken-1",
          attrs: {
            "flat": "flat"
          },
          nativeOn: {
            "click": function($event) {
              _vm.emailDialog = false;
              _vm.emailUser(_vm.selectedItem.uid, _vm.selectedItem.approvalStatus, _vm.selectedItem.groupId)
            }
          }
        }, [_vm._v("Yes")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-dialog', {
          attrs: {
            "lazy": "",
            "absolute": ""
          },
          model: {
            value: (_vm.dialog),
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.assignId(((props.item.groupId) + "/" + (props.item.id)))
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("delete_forever")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
          staticClass: "headline"
        }, [_vm._v("Really delete?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete '" + _vm._s(props.item.name) + "'?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          staticClass: "blue--text darken-1",
          attrs: {
            "flat": "flat"
          },
          nativeOn: {
            "click": function($event) {
              _vm.dialog = false
            }
          }
        }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
          staticClass: "blue--text darken-1",
          attrs: {
            "flat": "flat"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.deleteRow()
            }
          }
        }, [_vm._v("Yes")])], 1)], 1)], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n            From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + "\n          ")]
      }
    }], null, false, 4080790253)
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1226:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Companies\n    ")])], 1), _vm._v(" "), _c('v-card-title', [_c('v-flex', {
    staticClass: "mr-4",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.status_filter,
      "label": "Status",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.currentStatus),
      callback: function($$v) {
        _vm.currentStatus = $$v
      },
      expression: "currentStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "xs3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "loading": _vm.loadingTable,
      "items": _vm.allCompanies,
      "search": _vm.search,
      "rows-per-page-items": [15, 25, 50, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("actualDate")(props.item.submitdate)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n        " + _vm._s(props.item.firstname) + " " + _vm._s(props.item.lastname) + "\n      ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-avatar', {
          attrs: {
            "size": "24",
            "color": "secondary"
          }
        }, [(!props.item.companylogo && props.item.companylegalname) ? _c('span', {
          staticClass: "white--text"
        }, [_vm._v("\n            " + _vm._s(props.item.companylegalname.charAt(0)) + "\n          ")]) : _c('img', {
          attrs: {
            "src": props.item.companylogo,
            "alt": "logo",
            "size": "24"
          }
        })]), _vm._v(" "), _vm._v("\n        " + _vm._s(props.item.companylegalname) + "\n      ")], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("sliceText")(props.item.companydescription)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.verified === true ? 'Verified' : (props.item.rejected ?
          'Rejected' : 'Pending Action')))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-layout', {
          attrs: {
            "row": ""
          }
        }, [(props.item.verified === false) ? _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-btn', {
          staticClass: "green--text",
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.approveSubmission(props.item.id, props.item.uid)
            }
          }
        }, [_c('v-icon', [_vm._v("done")])], 1)], 1) : _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.rejectSubmission(props.item.id, props.item.uid)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("clear")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-btn', {
          staticClass: "blue--text",
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.selectItem(props.item);
              _vm.assignId(props.item.id, 'activeDialog')
            }
          }
        }, [_c('v-icon', [_vm._v("remove_red_eye")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-btn', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "slot": "activator",
            "icon": "",
            "medium": "",
            "disabled": props.item.verified !== true && props.item.rejected !== true
          },
          on: {
            "click": function($event) {
              _vm.selectItem(props.item);
              _vm.assignId(props.item.id, 'emailDialog')
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "medium": ""
          }
        }, [_vm._v("email")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-btn', {
          staticClass: "red--text",
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.selectItem(props.item);
              _vm.assignId(props.item.id, 'dialog')
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("delete_forever")])], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + "\n    ")]
      }
    }])
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "overlay": false,
      "scrollable": "",
      "lazy": "",
      "absolute": "",
      "width": "790px"
    },
    model: {
      value: (_vm.activeDialog),
      callback: function($$v) {
        _vm.activeDialog = $$v
      },
      expression: "activeDialog"
    }
  }, [_c('v-card', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    staticStyle: {
      "flex": "0 0 auto"
    },
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.activeDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Settings")])], 1), _vm._v(" "), (_vm.selectedItem.uid) ? _c('companyInfo', {
    attrs: {
      "props": _vm.selectedItem
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.emailDialog),
      callback: function($$v) {
        _vm.emailDialog = $$v
      },
      expression: "emailDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Confim Email")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to mail user "), _c('b', [_vm._v(_vm._s(_vm.selectedItem.firstname + " " + _vm.selectedItem.lastname))]), _vm._v("?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.emailDialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.emailDialog = false;
        _vm.emailUser(_vm.selectedItem.uid, _vm.selectedItem.verified, _vm.selectedItem.rejected)
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Really delete?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete "), _c('b', [_vm._v(_vm._s(_vm.selectedItem.firstname + " " + _vm.selectedItem.lastname) + "'s")]), _vm._v(" Submission?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteRow()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1227:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Activity Stream\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-switch', {
    staticClass: "rss-feed-switch",
    staticStyle: {
      "width": "120px",
      "padding-top": "17px"
    },
    attrs: {
      "label": "RSS Feed"
    },
    model: {
      value: (_vm.toogleRssFeedSchedule),
      callback: function($$v) {
        _vm.toogleRssFeedSchedule = $$v
      },
      expression: "toogleRssFeedSchedule"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-title', [_c('v-flex', {
    staticClass: "mr-4",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.status_filter,
      "label": "Status",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.currentStatus),
      callback: function($$v) {
        _vm.currentStatus = $$v
      },
      expression: "currentStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mr-4",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.default_filter,
      "label": "Date Range",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "activity-search",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.feeds,
      "search": _vm.search,
      "pagination": _vm.pagination,
      "rows-per-page-items": [15, 25, 50, 100]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("actualDate")(props.item.posteddate)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "avatar ml-2",
          staticStyle: {
            "height": "24px",
            "width": "24px"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.returnLogo(props.item.avatar)
          }
        })]), _vm._v("\n        " + _vm._s(props.item.user.firstname) + " " + _vm._s(props.item.user.lastname) + "\n      ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n        " + _vm._s(props.item.user.company.companylegalname) + "\n      ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("sliceText")(props.item.content)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("status")(props.item.approvalStatus)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-layout', {
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "green--text",
          attrs: {
            "slot": "activator",
            "disabled": props.item.approvalStatus === 1,
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.changeStatus(1, props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("done")])], 1), _vm._v(" "), _c('span', [_vm._v("Approve")])], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "slot": "activator",
            "disabled": props.item.approvalStatus === 2,
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.changeStatus(2, props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Reject")])], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-dialog', {
          attrs: {
            "lazy": "",
            "absolute": "",
            "max-width": "790px"
          },
          model: {
            value: (props.item.activeDialog),
            callback: function($$v) {
              _vm.$set(props.item, "activeDialog", $$v)
            },
            expression: "props.item.activeDialog"
          }
        }, [_c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('v-card', [_c('v-layout', {
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs12": "",
            "sm12": ""
          }
        }, [_c('v-toolbar', {
          attrs: {
            "color": "white",
            "prominent": ""
          }
        }, [_c('v-toolbar-title', {
          staticClass: "body-2 grey--text"
        }, [_vm._v("Post Details")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text darken-1",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              props.item.activeDialog = false
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
          staticClass: "pa-3",
          attrs: {
            "two-line": "",
            "dense": ""
          }
        }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(props.item.user.firstname + ' ' + props.item.user.lastname))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(props.item.user.jobtitle) + " "), (props.item.user.jobtitle) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v("\n                          " + _vm._s(props.item.user.company.companylegalname))])], 1)], 1), _vm._v(" "), (!props.item.type) ? _c('v-card-text', [_vm._v(_vm._s(props.item.content))]) : _vm._e(), _vm._v(" "), (props.item.type && props.item.type === 'rss') ? _c('v-card-text', [_c('b', [_vm._v(_vm._s(props.item.title))]), _vm._v(" "), _c('div', {
          staticClass: "mt-1"
        }, [_vm._v(_vm._s(props.item.content))]), _vm._v(" "), _c('div', {
          staticClass: "mt-1"
        }, [_c('a', {
          attrs: {
            "rel": "noopener",
            "href": props.item.link,
            "target": "_blank"
          }
        }, [_vm._v("Link to article")])]), _vm._v(" "), _c('div', {
          staticClass: "mt-1"
        }, [_vm._v(_vm._s(_vm.itemRssFeedCategories(props.item)))])]) : _vm._e(), _vm._v(" "), _c('v-divider', {
          staticClass: "mt-0 px-2"
        }), _vm._v(" "), _c('v-layout', {
          attrs: {
            "row": "",
            "wrap": "",
            "pa-3": ""
          }
        }, [(props.item.video) ? _c('v-flex', {
          class: {
            'xs12': true, 'md6': props.item.video && props.item.attachmentUrl, 'md12': props.item.video && !props.item.attachmentUrl
          }
        }, [_c('iframe', {
          staticStyle: {
            "width": "100%",
            "height": "260px",
            "border": "0px"
          },
          attrs: {
            "allowfullscreen": "",
            "src": props.item.video.embedUrl
          }
        })]) : _vm._e(), _vm._v(" "), (props.item.attachmentUrl) ? _c('v-flex', {
          staticClass: "background-image",
          class: {
            'xs12': true, 'md6': props.item.attachmentUrl && props.item.video, 'md12': props.item.attachmentUrl && !props.item.video
          },
          style: ({
            'backgroundImage': ("url(" + (props.item.attachmentUrl) + ")")
          })
        }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "icon": "",
            "medium": "",
            "disabled": props.item.approvalStatus !== 1 && props.item.approvalStatus !== 2
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.selectItem(props.item);
              _vm.assignId(props.item.id, 'emailDialog')
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "medium": ""
          }
        }, [_vm._v("email")])], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": "",
            "sm3": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.selectItem(props.item);
              _vm.assignId(props.item.id, 'dialog')
            }
          }
        }, [_c('v-icon', [_vm._v("delete_forever")])], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + "\n    ")]
      }
    }])
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.emailDialog),
      callback: function($$v) {
        _vm.emailDialog = $$v
      },
      expression: "emailDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Confim Email")])]), _vm._v(" "), (_vm.selectedItem.user) ? _c('v-card-text', [_vm._v("Are you sure you want to mail user "), _c('b', [_vm._v(_vm._s(_vm.selectedItem.user.firstname) + " " + _vm._s(_vm.selectedItem.user.lastname))]), _vm._v("?")]) : _vm._e(), _vm._v(" "), (_vm.selectedItem.approvalStatus === 1) ? _c('v-card-text', [_c('v-checkbox', {
    attrs: {
      "label": "Would you like to notify all users of the new post?"
    },
    model: {
      value: (_vm.notifyAllUsers),
      callback: function($$v) {
        _vm.notifyAllUsers = $$v
      },
      expression: "notifyAllUsers"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.emailDialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.emailDialog = false;
        _vm.emailUser(_vm.selectedItem.uid, _vm.selectedItem.approvalStatus)
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Really delete?")])]), _vm._v(" "), (_vm.selectedItem.user) ? _c('v-card-text', [_vm._v("Are you sure you want to delete "), _c('b', [_vm._v(_vm._s(_vm.selectedItem.user.firstname) + " " + _vm._s(_vm.selectedItem.user.lastname) + "'s")]), _vm._v(" post?")]) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteRow()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1229:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "xs6 mt-1",
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('img', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "src": _vm.props.companylogo,
      "height": "120px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "white--text pl-2 mt-2",
    attrs: {
      "src": _vm.props.companylogo,
      "contain": true
    }
  }, [_c('v-layout', {
    staticClass: "media",
    attrs: {
      "column": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-card-title', {
    staticClass: "white--text pl-2"
  }, [_c('div', {
    staticClass: "display-1 pl-2",
    staticStyle: {
      "color": "#000",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.props.companylegalname) + "\n          "), (_vm.props.verified) ? _c('v-icon', {
    attrs: {
      "small": "",
      "right": true,
      "primary": ""
    }
  }, [_vm._v("verified_user")]) : _vm._e(), _vm._v(" "), (!_vm.props.verified) ? _c('v-icon', {
    attrs: {
      "color": "red",
      "small": "",
      "right": true
    }
  }, [_vm._v("error")]) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "ma-1 mt-1",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "light": "",
      "flat": ""
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Full Name")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.firstname) + " " + _vm._s(_vm.props.lastname))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Street Address")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.streetaddress))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("phone")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Phone Number")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.phonenumber))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("mail")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Email Address")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.email))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("settings_overscan")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Federal Contractor")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.fedcontractor ? 'Yes' : 'No'))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("toc")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Federal Contractor Type")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.fedcontractortype))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("subject")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Security Clearance")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.securityclearance))])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "ma-1 mt-1",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "light": "",
      "flat": ""
    }
  }, [_c('v-list', [_c('v-list-tile')], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("explore")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Duns Number")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.dunsnumber))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("extension")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Cage ID")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.cagecode))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("timeline")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Primary NAICS Code")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.primarynaicscode))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("dialpad")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Additional NAICS Codes")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.additionalnaicscodes))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("dialpad")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Primary PSC Code")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.primarypsccode))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("dialpad")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Additional PSC Codes")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.additionalpsccodes))])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "ma-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "light": "",
      "flat": ""
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("assignment_ind")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Specialties")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.specialties))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("pan_tool")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Capabilities")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.capabilities))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("chrome_reader_mode")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Capabilities Statements")]), _vm._v(" "), _c('v-list-tile-title', [(_vm.props.capabilitiesstatement) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.props.capabilitiesstatement,
      "round": "",
      "color": "red lighten-1",
      "dark": ""
    }
  }, [_vm._v("View PDF")]) : _vm._e(), _vm._v(" "), (!_vm.props.capabilitiesstatement) ? _c('span', [_vm._v("Not Available")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("description")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Description")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(_vm.props.companydescription) + "\n                ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1231:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.dunsnumber))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Duns Number")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.cageid))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Cage ID")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Federal Contractor")])], 1), _vm._v(" "), _c('v-list-action', [(_vm.props.item.fedcontractor) ? _c('v-chip', {
    attrs: {
      "color": "green",
      "text-color": "white"
    }
  }, [_c('v-card-text', [_vm._v("YES")])], 1) : _vm._e(), _vm._v(" "), (!_vm.props.item.fedcontractor) ? _c('v-chip', {
    attrs: {
      "color": "red",
      "text-color": "white"
    }
  }, [_c('v-card-text', [_vm._v("NO")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Federal Contractor Type")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.fedcontractortype))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Security Clearance")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.securityclearance))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Primary NAICS Codes")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.primarynaicscode))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Additional NAICS Codes")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.additionalnaicscodes))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Primary PSC Codes")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.primarypsccode))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Additional PSC Codes")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.additionalpsccodes))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1234:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Group Posts\n    ")])], 1), _vm._v(" "), _c('v-card-title', [_c('v-flex', {
    staticClass: "mr-4",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.status_filter,
      "label": "Status",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.currentStatus),
      callback: function($$v) {
        _vm.currentStatus = $$v
      },
      expression: "currentStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mr-4",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.default_filter,
      "label": "Date Range",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mr-4",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.feeds,
      "search": _vm.search,
      "pagination": _vm.pagination,
      "rows-per-page-items": [15, 25, 50, 100]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          staticClass: "no-wrap-cell"
        }, [_vm._v(_vm._s(_vm._f("actualDate")(props.item.posteddate)))]), _vm._v(" "), _c('td', {
          staticClass: "no-wrap-cell"
        }, [_c('div', {
          staticClass: "avatar ml-2 mr-2",
          staticStyle: {
            "height": "24px",
            "width": "24px"
          }
        }, [_c('img', {
          attrs: {
            "src": props.item.avatar,
            "alt": _vm.returnName(props.item.user.firstname)
          }
        })]), _vm._v("\n          " + _vm._s(_vm.returnName(props.item.user)) + "\n        ")]), _vm._v(" "), _c('td', {
          staticClass: "no-wrap-cell"
        }, [_vm._v(_vm._s(props.item.user.company.companylegalname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("sliceText")(props.item.content)))]), _vm._v(" "), _c('td', {
          staticClass: "no-wrap-cell"
        }, [_vm._v(_vm._s(_vm._f("status")(props.item.approvalStatus)))]), _vm._v(" "), _c('td', {
          staticClass: "no-wrap-cell"
        }, [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "green--text",
          attrs: {
            "slot": "activator",
            "disabled": props.item.approvalStatus === 1,
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.changeStatus(1, ((props.item.groupId) + "/" + (props.item.id)))
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("done")])], 1), _vm._v(" "), _c('span', [_vm._v("Approve")])], 1), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "slot": "activator",
            "disabled": props.item.approvalStatus === 2,
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.changeStatus(2, ((props.item.groupId) + "/" + (props.item.id)))
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Reject")])], 1), _vm._v(" "), _c('v-dialog', {
          attrs: {
            "lazy": "",
            "absolute": "",
            "width": "790px"
          },
          model: {
            value: (props.item.activeDialog),
            callback: function($$v) {
              _vm.$set(props.item, "activeDialog", $$v)
            },
            expression: "props.item.activeDialog"
          }
        }, [_c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('v-card', [_c('v-layout', {
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs12": "",
            "sm12": ""
          }
        }, [_c('v-card', [_c('v-toolbar', {
          attrs: {
            "card": "",
            "color": "white",
            "prominent": ""
          }
        }, [_c('v-toolbar-title', {
          staticClass: "body-2 grey--text"
        }, [_vm._v("Post Details")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text darken-1",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              props.item.activeDialog = false
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
          staticClass: "pa-3",
          attrs: {
            "two-line": "",
            "dense": ""
          }
        }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(props.item.user.firstname + ' ' + props.item.user.lastname))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(props.item.user.jobtitle) + " "), (props.item.user.jobtitle) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" " + _vm._s(props.item.user.company.companylegalname))])], 1)], 1), _vm._v(" "), _c('v-card-text', {
          staticStyle: {
            "height": "100px"
          }
        }, [_vm._v(_vm._s(props.item.content))]), _vm._v(" "), _c('v-divider', {
          staticClass: "mt-0 px-2"
        }), _vm._v(" "), _c('v-card', {
          staticClass: "pa-3"
        }, [_c('v-layout', {
          attrs: {
            "row": "",
            "wrap": ""
          }
        }, [(props.item.video) ? _c('v-flex', {
          class: {
            'xs12': true, 'md6': props.item.video && props.item.attatchmentUrl, 'md12': props.item.video && !props.item.attatchmentUrl
          }
        }, [_c('iframe', {
          staticStyle: {
            "width": "100%",
            "height": "260px",
            "border": "0px"
          },
          attrs: {
            "allowfullscreen": "",
            "src": props.item.video.embedUrl
          }
        })]) : _vm._e(), _vm._v(" "), (props.item.attatchmentUrl) ? _c('v-flex', {
          staticClass: "background-image",
          class: {
            'xs12': true, 'md6': props.item.attatchmentUrl && props.item.video, 'md12': props.item.attatchmentUrl && !props.item.video
          },
          style: ({
            'backgroundImage': ("url(" + (props.item.attatchmentUrl) + ")")
          })
        }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions')], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
          attrs: {
            "lazy": "",
            "absolute": "",
            "width": "500px"
          },
          model: {
            value: (_vm.dialog),
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.assignId(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("delete_forever")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
          staticClass: "headline"
        }, [_vm._v("Really delete?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete '" + _vm._s(_vm._f("sliceText")(props.item.content)) + "'?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          staticClass: "blue--text darken-1",
          attrs: {
            "flat": "flat"
          },
          nativeOn: {
            "click": function($event) {
              _vm.dialog = false
            }
          }
        }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
          staticClass: "blue--text darken-1",
          attrs: {
            "flat": "flat"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.deleteRow()
            }
          }
        }, [_vm._v("Yes")])], 1)], 1)], 1)], 1)])]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + "\n    ")]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1235:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Specialties")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.specialties))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Capabilities")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.capabilities))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Capabilities Statements")])], 1), _vm._v(" "), _c('v-card-action', [(_vm.props.item.capabilitiesstatement) ? _c('v-btn', {
    attrs: {
      "target": "_blank",
      "href": _vm.props.item.capabilitiesstatement,
      "round": "",
      "color": "red lighten-1",
      "dark": ""
    }
  }, [_vm._v("View PDF")]) : _vm._e(), _vm._v(" "), (!_vm.props.item.capabilitiesstatement) ? _c('v-card-text', [_vm._v("Not Available")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Request_activity_vue__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Request_activity_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Request_activity_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Request_groupposts_vue__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Request_groupposts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Request_groupposts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Request_groupevents_vue__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Request_groupevents_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Request_groupevents_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Request_events_vue__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Request_events_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Request_events_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Request_company_vue__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Request_company_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Request_company_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_main_menu_MainMenuComponent_vue__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_main_menu_MainMenuComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_main_menu_MainMenuComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Toolbar_vue__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Toolbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Toolbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_AdminSideBar_vue__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_AdminSideBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Components_AdminSideBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_PageFooter_vue__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_PageFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Components_PageFooter_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Activity: __WEBPACK_IMPORTED_MODULE_0__Request_activity_vue___default.a,
    GroupPosts: __WEBPACK_IMPORTED_MODULE_1__Request_groupposts_vue___default.a,
    Events: __WEBPACK_IMPORTED_MODULE_3__Request_events_vue___default.a,
    Company: __WEBPACK_IMPORTED_MODULE_4__Request_company_vue___default.a,
    MainMenu: __WEBPACK_IMPORTED_MODULE_5__components_main_menu_MainMenuComponent_vue___default.a,
    AdminSideBarMenu: __WEBPACK_IMPORTED_MODULE_7__Components_AdminSideBar_vue___default.a,
    UserToolbar: __WEBPACK_IMPORTED_MODULE_6__components_Toolbar_vue___default.a,
    GroupEvents: __WEBPACK_IMPORTED_MODULE_2__Request_groupevents_vue___default.a,
    PageFooter: __WEBPACK_IMPORTED_MODULE_8__Components_PageFooter_vue___default.a
  },
  mounted: function mounted() {
    var payload = {
      meta: {
        'h1': 'Requests',
        'title': 'Requests',
        'description': 'Admin Settings',
        'keywords': '',
        'requiresAuth': true
      }
    };
    document.title = payload.meta.title;
    this.$store.commit('setHeaderInfo', payload);
  },
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    }
  },
  data: function data() {
    return {
      drawer: true,
      h1: window.title
    };
  },
  methods: {
    onDismiss: function onDismiss() {
      this.$store.dispatch('setError', null);
      this.$store.dispatch('setProcess', 'null');
    },
    triggerDrawer: function triggerDrawer() {
      this.drawer = !this.drawer;
    },
    isSelectedTab: function isSelectedTab(tabName) {
      var urlSection = this.$route.params.id || 'activity';
      return tabName === urlSection;
    }
  }
};

/***/ }),

/***/ 1424:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".my_white ul li a[data-v-d7a8ac46]{color:#fff!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/RequestView.vue"],"names":[],"mappings":"AACA,mCACE,oBAAwB,CACzB","file":"RequestView.vue","sourcesContent":["\n.my_white ul li a[data-v-d7a8ac46] {\n  color: white !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1513:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1424);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("29c2f492", content, true, {});

/***/ }),

/***/ 1727:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "height": "100%",
      "padding": "0"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "fill-height": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('AdminSideBarMenu'), _vm._v(" "), _c('v-flex', {
    staticClass: "dashboard-view"
  }, [(_vm.isSelectedTab('activity')) ? _c('div', [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Requests")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Activity")])], 1), _vm._v(" "), _c('activity')], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('events')) ? _c('div', [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Requests")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Events")])], 1), _vm._v(" "), _c('events')], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('companies')) ? _c('div', [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Requests")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Companies")])], 1), _vm._v(" "), _c('company')], 1) : _vm._e(), _vm._v(" "), _c('PageFooter')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1513)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1300),
  /* template */
  __webpack_require__(1727),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d7a8ac46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(833)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(831),
  /* template */
  __webpack_require__(834),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      show: false,
      unread: 0,
      contacts: []
    };
  },
  computed: {
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    privileges: function privileges() {
      return this.$store.getters.getUserPrivileges;
    }
  },
  methods: {
    openChat: function openChat() {
      window.$applozic('#mck-sidebox').mckModal('show');
      window.$applozic.fn.applozic('loadTab', '');
      window.$('html').addClass('sidebox-open');
      this.setDefaultContacts();
    },
    setDefaultContacts: function setDefaultContacts() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var self, contactSnap, contacts, users, parentNode, noConversationNode, mckInner, nodes, fragment;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;
                _context.next = 3;
                return _this.$firebase.database().ref('default_chat_contact').once('value');

              case 3:
                contactSnap = _context.sent;
                contacts = contactSnap.val() || [];
                users = _this.$store.getters.fetchUsers;
                parentNode = document.getElementById('mck-contact-list');
                noConversationNode = document.getElementById('mck-no-conversations');
                mckInner = document.querySelector('#mck-message-cell .mck-message-inner');
                nodes = contacts.reduce(function (d, contact) {
                  var user = users.find(function (user) {
                    return user.uid === contact.uid;
                  }); // check if already exist

                  if (user) {
                    var contactExist = document.getElementById("li-user-".concat(user.uid));
                    if (contactExist) return d + '';
                    var node = self.getNode(user);
                    return d + node;
                  }

                  return d;
                }, '');
                fragment = document.createRange().createContextualFragment(nodes);

                if (!parentNode) {
                  mckInner.innerHTML = '<ul id="mck-contact-list" class="mck-contact-list mck-nav mck-nav-tabs mck-nav-stacked">';
                  parentNode = document.getElementById('mck-contact-list');
                }

                if (noConversationNode) {
                  setTimeout(function () {
                    noConversationNode.classList.remove('vis');
                    noConversationNode.classList.add('n-vis');
                  }, 800);
                }

                parentNode.prepend(fragment);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getNode: function getNode(user) {
      var avatar = user.avatar.indexOf('http') >= 0 ? user.avatar : "".concat(window.location.protocol, "//").concat(window.location.host).concat(user.avatar);
      var fullName = "".concat(user.firstname, " ").concat(user.lastname);
      return "\n      <li id=\"li-user-".concat(user.uid, "\" class=\"li-user-").concat(user.uid, " ").concat(user.uid, "\"\n        data-msg-time=\"1539049156786\"><a class=\"applozic-launcher\" href=\"#\" target=\"_self\" data-mck-conversationid=\"\"\n          data-mck-id=\"").concat(user.uid, "\" data-mck-clientgroupid=\"\" data-isgroup=\"false\">\n          <div class=\"mck-row\" title=\"").concat(fullName, "\">\n            <div class=\"mck-conversation-topic mck-truncate n-vis\"></div>\n            <div class=\"blk-lg-3\"><img src=\"").concat(avatar, "\"></div>\n            <div class=\"blk-lg-9\">\n              <div class=\"mck-row\">\n                <div class=\"blk-lg-8 mck-cont-name mck-truncate\">\n                  <div class=\"mck-ol-status n-vis\"><span class=\"mck-ol-icon\" title=\"Online\"></span>&nbsp;</div><strong>").concat(fullName, "</strong>\n                </div>\n                <div class=\"mck-text-muted move-right mck-cont-msg-date mck-truncate blk-lg-4\"></div>\n              </div>\n              <div class=\"mck-row\">\n                <div class=\"mck-cont-msg-wrapper blk-lg-6 mck-truncate msgTextExpr\">\n                  <p>Hello, how can I help you?</p>\n                </div>\n                <div class=\"mck-unread-count-box move-right mck-truncate n-vis\"><span class=\"mck-unread-count-text\">0</span></div>\n              </div>\n            </div>\n          </div>\n        </a>\n      </li>\n    ");
    }
  },
  beforeDestroy: function beforeDestroy() {
    var chatTotalUnreadCountId = Number(localStorage.getItem('chatTotalUnreadCountId'));
    window.clearInterval(chatTotalUnreadCountId);
    localStorage.removeItem('chatTotalUnreadCountId');
  },
  mounted: function mounted() {
    var _this2 = this;

    var self = this;
    var path = this.$route.path;
    this.$store.dispatch('loadUsers');
    if (!['/user/feed', '/contractors'].includes(path)) return;
    window.$applozic && window.$applozic.fn.applozic({
      appId: 'tsvcommunityxchange3b1149dc15a',
      userId: this.user.uid,
      userName: "".concat(this.user.firstname, "-").concat(this.user.lastname),
      imageLink: this.user.avatar,
      email: this.user.email,
      labels: {
        'last.seen.on': 'Last seen'
      },
      contactNumber: '',
      desktopNotification: true,
      source: '1',
      group: false,
      video: true,
      voice: true,
      notificationIconLink: 'https://www.applozic.com/favicon.ico',
      authenticationTypeId: 1,
      accessToken: '',
      locShare: false,
      // googleApiKey: "AIzaSyDKfWHzu9X7Z2hByeW4RRFJrD9SizOzZt4",
      googleApiKey: 'AIzaSyBCkHJdW4ChFLJ8cqJghc-LlhVU_FAl5G0',
      googleMapScriptLoaded: true,
      // mapStaticAPIkey: "AIzaSyCWRScTDtbt8tlXDr6hiceCsU83aS2UuZw",
      autoTypeSearchEnabled: true,
      loadOwnContacts: true,
      olStatus: true,
      onInit: function onInit(response) {
        if (response === 'success') {
          // calling function load contacts
          // const contactsJSON = self.$store.getters.fetchUsers
          //   .filter(val => val.id !== self.user.id)
          //   .map(user => {
          //     return {
          //       userId: user.id,
          //       displayName: `${user.firstname} ${user.lastname}`,
          //       imageLink:
          //         user.avatar.indexOf("http") < 0
          //           ? `${window.location.protocol}//${window.location.host}${
          //               user.avatar
          //             }`
          //           : user.avatar
          //     };
          //   });
          // self.contacts = contactsJSON;
          // $applozic.fn.applozic("loadContacts", { contacts: contactsJSON });
          // var startNew = document.getElementById('mck-msg-new')
          // startNew.addEventListener("mousemove", () => {
          //   $applozic.fn.applozic("loadContacts", { contacts: self.contacts });
          // });
          var closeButton = document.querySelector('.mck-box-close.mck-close-sidebox');
          closeButton.addEventListener('click', function () {
            window.$('html').removeClass('sidebox-open');
          });
          var chatTotalUnreadCountIntervalId = setInterval(function () {
            window.$applozic.fn.applozic('getUserDetail', {
              callback: function callback(response) {
                if (response.status === 'success') {
                  self.unread = response.data.totalUnreadCount;
                }
              }
            });
          }, 3000);
          window.localStorage.setItem('chatTotalUnreadCountId', chatTotalUnreadCountIntervalId);

          _this2.setDefaultContacts(); // watch for back icon click


          var backIconNodes = document.querySelectorAll('.mck-tab-link a.mck-conversation-tab-link');

          var _iterator = _createForOfIteratorHelper(backIconNodes),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var node = _step.value;
              node.addEventListener('click', function () {
                self.setDefaultContacts();
              });
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else {// error in user login/register (you can hide chat button or refresh page)
        }
      },
      onTabClicked: function onTabClicked(response) {},
      contactDisplayName: function contactDisplayName(userId) {
        var users = self.$store.getters.fetchUsers;
        var contactUser = users.find(function (user) {
          return user.uid === userId;
        });

        if (contactUser) {
          return "".concat(contactUser.firstname, " ").concat(contactUser.lastname);
        }
      },
      contactDisplayImage: function contactDisplayImage(userId) {
        var users = self.$store.getters.fetchUsers;
        var contactUser = users.find(function (user) {
          return user.uid === userId;
        });

        if (contactUser) {
          return contactUser.avatar.indexOf('http') < 0 ? "".concat(window.location.protocol, "//").concat(window.location.host).concat(contactUser.avatar) : contactUser.avatar;
        }
      }
    });
  }
};

/***/ }),

/***/ 832:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".sidebox-open{overflow:hidden!important}.chatbutton{width:66px;height:66px}#mck-contact-search-list{display:none!important}.mck-box input{line-height:inherit!important}.mck-box input::-webkit-input-placeholder{line-height:inherit!important}.mck-box input::-moz-placeholder{line-height:inherit!important}.mck-box input::-ms-input-placeholder{line-height:inherit!important}.mck-box input::placeholder{line-height:inherit!important}.mck-sidebox.fade.in{width:100%!important}.mck-alpha-contact-image img{width:43px!important;height:43px!important}.row.mck-vid-overlay-footer.mck-flex-footer{margin:0!important}.mck-vid-scr-controls{width:100%!important;display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important;-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important}.row.mck-vid-overlay-header{padding-top:20px!important}.mck-vid-icon span{color:#fff!important}.mck-videocall-image{width:50px!important;height:50px!important;border-radius:100%!important}.footer-controls{width:auto!important;float:none!important;margin:0!important}.mck-contact-list .blk-lg-8{width:calc(100% - 55px)!important}.mck-running-on.vis{display:none!important}.mck-msg-box{min-height:0!important;font-size:15px!important;display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important;-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important;padding:16px 14px 10px!important}.applozic-vid-container{width:100%!important;padding:0!important;max-width:none!important}#mck-sidebox-launcher,.mck-sidebox-launcher{display:none!important}#mck-vid-icon{color:#fff!important;position:relative}#mck-vid-icon span{width:150px;display:block;position:absolute;left:-43px}.mck-vid-overlay-footer{margin-left:0!important}.mck-vid-scr-controls .footer-controls,.mck-vid-scr-controls .footer-controls button{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.mck-vid-scr-controls .footer-controls button{-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important;-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important;margin:4px!important}#mck-microfone-mute-btn{border-radius:50%;height:56px!important;width:56px!important}.unread{position:absolute!important;z-index:99999!important;color:#fff!important;font-size:12px!important;font-weight:700!important;background:red!important;top:0!important;right:0!important;height:20px!important;width:20px!important;border-radius:50%!important;-webkit-transform:rotate(0deg)!important;transform:rotate(0deg)!important;opacity:1!important;left:auto!important}", "", {"version":3,"sources":["/home/circleci/repo/src/components/chat/sideboxChat.vue"],"names":[],"mappings":"AACA,cACE,yBAA4B,CAC7B,AACD,YACE,WAAY,AACZ,WAAa,CACd,AACD,yBACE,sBAAyB,CAC1B,AACD,eACE,6BAAgC,CACjC,AACD,0CACE,6BAAgC,CACjC,AACD,iCACE,6BAAgC,CACjC,AACD,sCACE,6BAAgC,CACjC,AACD,4BACE,6BAAgC,CACjC,AACD,qBACE,oBAAuB,CACxB,AACD,6BACE,qBAAuB,AACvB,qBAAwB,CACzB,AACD,4CACE,kBAAqB,CACtB,AACD,sBACE,qBAAuB,AACvB,8BAAgC,AAChC,8BAAgC,AAChC,uBAAyB,AACzB,mCAAqC,AACjC,gCAAkC,AAC9B,6BAA+B,AACvC,kCAAoC,AAChC,+BAAiC,AAC7B,gCAAmC,CAC5C,AACD,4BACE,0BAA6B,CAC9B,AACD,mBACE,oBAAuB,CACxB,AACD,qBACE,qBAAuB,AACvB,sBAAwB,AACxB,4BAA+B,CAChC,AACD,iBACE,qBAAuB,AACvB,qBAAuB,AACvB,kBAAqB,CACtB,AACD,4BACE,iCAAoC,CACrC,AACD,oBACE,sBAAyB,CAC1B,AACD,aACE,uBAA2B,AAC3B,yBAA2B,AAC3B,8BAAgC,AAChC,8BAAgC,AAChC,uBAAyB,AACzB,kCAAoC,AAChC,+BAAiC,AAC7B,iCAAmC,AAC3C,mCAAqC,AACjC,gCAAkC,AAC9B,6BAA+B,AACvC,gCAAwC,CACzC,AACD,wBACE,qBAAuB,AACvB,oBAAwB,AACxB,wBAA2B,CAC5B,AAID,4CACE,sBAAyB,CAC1B,AACD,cACE,qBAAuB,AACvB,iBAAmB,CACpB,AACD,mBACE,YAAa,AACb,cAAe,AACf,kBAAmB,AACnB,UAAY,CACb,AACD,wBACE,uBAA4B,CAC7B,AAMD,qFAJE,8BAAgC,AAChC,8BAAgC,AAChC,sBAAyB,CAa1B,AAXD,8CAIE,mCAAqC,AACjC,gCAAkC,AAC9B,6BAA+B,AACvC,kCAAoC,AAChC,+BAAiC,AAC7B,iCAAmC,AAC3C,oBAAuB,CACxB,AACD,wBACE,kBAAmB,AACnB,sBAAwB,AACxB,oBAAuB,CACxB,AACD,QACE,4BAA8B,AAC9B,wBAA0B,AAC1B,qBAAuB,AACvB,yBAA2B,AAC3B,0BAA4B,AAC5B,yBAA2B,AAC3B,gBAAoB,AACpB,kBAAsB,AACtB,sBAAwB,AACxB,qBAAuB,AACvB,4BAA8B,AAC9B,yCAA2C,AAC3C,iCAAmC,AACnC,oBAAsB,AACtB,mBAAsB,CACvB","file":"sideboxChat.vue","sourcesContent":["\n.sidebox-open {\n  overflow: hidden !important;\n}\n.chatbutton {\n  width: 66px;\n  height: 66px;\n}\n#mck-contact-search-list {\n  display: none !important;\n}\n.mck-box input {\n  line-height: inherit !important;\n}\n.mck-box input::-webkit-input-placeholder {\n  line-height: inherit !important;\n}\n.mck-box input::-moz-placeholder {\n  line-height: inherit !important;\n}\n.mck-box input::-ms-input-placeholder {\n  line-height: inherit !important;\n}\n.mck-box input::placeholder {\n  line-height: inherit !important;\n}\n.mck-sidebox.fade.in {\n  width: 100% !important;\n}\n.mck-alpha-contact-image img {\n  width: 43px !important;\n  height: 43px !important;\n}\n.row.mck-vid-overlay-footer.mck-flex-footer {\n  margin: 0 !important;\n}\n.mck-vid-scr-controls {\n  width: 100% !important;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n}\n.row.mck-vid-overlay-header {\n  padding-top: 20px !important;\n}\n.mck-vid-icon span {\n  color: #fff !important;\n}\n.mck-videocall-image {\n  width: 50px !important;\n  height: 50px !important;\n  border-radius: 100% !important;\n}\n.footer-controls {\n  width: auto !important;\n  float: none !important;\n  margin: 0 !important;\n}\n.mck-contact-list .blk-lg-8 {\n  width: calc(100% - 55px) !important;\n}\n.mck-running-on.vis {\n  display: none !important;\n}\n.mck-msg-box {\n  min-height: 0px !important;\n  font-size: 15px !important;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  padding: 16px 14px 10px 14px !important;\n}\n.applozic-vid-container {\n  width: 100% !important;\n  padding: 0px !important;\n  max-width: none !important;\n}\n#mck-sidebox-launcher {\n  display: none !important;\n}\n.mck-sidebox-launcher {\n  display: none !important;\n}\n#mck-vid-icon {\n  color: #fff !important;\n  position: relative;\n}\n#mck-vid-icon span {\n  width: 150px;\n  display: block;\n  position: absolute;\n  left: -43px;\n}\n.mck-vid-overlay-footer {\n  margin-left: 0px !important;\n}\n.mck-vid-scr-controls .footer-controls {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n}\n.mck-vid-scr-controls .footer-controls button {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  margin: 4px !important;\n}\n#mck-microfone-mute-btn {\n  border-radius: 50%;\n  height: 56px !important;\n  width: 56px !important;\n}\n.unread {\n  position: absolute !important;\n  z-index: 99999 !important;\n  color: #fff !important;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  background: red !important;\n  top: 0px !important;\n  right: 0px !important;\n  height: 20px !important;\n  width: 20px !important;\n  border-radius: 50% !important;\n  -webkit-transform: rotate(0deg) !important;\n  transform: rotate(0deg) !important;\n  opacity: 1 !important;\n  left: auto !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 833:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(832);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("1e24f439", content, true, {});

/***/ }),

/***/ 834:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.path === '/user/feed') ? _c('div', [(_vm.privileges.chat.private_chat) ? _c('v-btn', {
    staticClass: "chatbutton primary",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openChat.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    staticClass: "chaticon"
  }, [_vm._v("chat")]), _vm._v(" "), (_vm.unread) ? _c('span', {
    staticClass: "unread"
  }, [_vm._v(_vm._s(_vm.unread))]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(844)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(842),
  /* template */
  __webpack_require__(846),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-060504ef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 842:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      items: [{
        icon: '',
        text: 'Home',
        link: '/admin/settings/home'
      }, {
        icon: '',
        text: 'Settings',
        link: '/admin/settings/pages',
        children: [{
          icon: '',
          text: 'General Settings',
          link: '/admin/settings/pages',
          query: {
            page: 'general-settings'
          }
        }, {
          icon: '',
          text: 'Email Settings',
          link: '/admin/settings/pages',
          query: {
            page: 'email-settings'
          }
        }, {
          icon: '',
          text: 'Directory',
          link: '/admin/settings/pages',
          query: {
            page: 'directory'
          }
        }, {
          icon: '',
          text: 'Resources',
          link: '/admin/settings/pages',
          query: {
            page: 'resources'
          }
        }, {
          icon: '',
          text: 'Opportunities',
          link: '/admin/settings/pages',
          query: {
            page: 'opportunities'
          }
        }, {
          icon: '',
          text: 'History',
          link: '/admin/settings/pages',
          query: {
            page: 'history'
          }
        }, {
          icon: '',
          text: 'DoD Contract Analytics',
          link: '/admin/settings/pages',
          query: {
            page: 'dod-contract-analytics'
          }
        }, {
          icon: '',
          text: 'Bid Alerts',
          link: '/admin/settings/pages',
          query: {
            page: 'bid_alerts'
          }
        }, {
          icon: '',
          text: 'Questionnaire',
          link: '/admin/settings/pages',
          query: {
            page: 'questionnaire'
          }
        }, {
          icon: '',
          text: 'Favorites',
          link: '/admin/settings/pages',
          query: {
            page: 'favorites'
          }
        }, {
          icon: '',
          text: 'Tracking',
          link: '/admin/settings/pages',
          query: {
            page: 'tracking'
          }
        }]
      }, {
        icon: '',
        text: 'Users',
        link: '/admin/settings/users',
        children: [{
          icon: '',
          text: 'Manage Users',
          link: '/admin/settings/users',
          query: {
            page: 'manage-users'
          }
        }, {
          icon: '',
          text: 'Usage Tracking',
          link: '/admin/settings/users',
          query: {
            page: 'usage-tracking'
          }
        }, {
          icon: '',
          text: 'Default Chat Contact',
          link: '/admin/settings/users',
          query: {
            page: 'default-chat-contact'
          }
        }]
      }, {
        icon: '',
        text: 'Access',
        link: '/admin/settings/priviledges'
      }, {
        icon: '',
        text: 'Resources',
        link: '/admin/resources/all'
      }, {
        icon: '',
        text: 'Companies',
        link: '/admin/companies',
        children: [{
          icon: '',
          text: 'Update Company',
          link: '/admin/companies/update-company'
        }, {
          icon: '',
          text: 'Add Company',
          link: '/admin/companies/add-company'
        }]
      }, {
        icon: '',
        text: 'Requests',
        link: '/admin/settings/requests',
        children: [{
          icon: '',
          text: 'Activity Stream',
          link: '/admin/settings/requests',
          query: {
            page: 'activity'
          }
        }, {
          icon: '',
          text: 'Events',
          link: '/admin/settings/requests',
          query: {
            page: 'events'
          }
        }, {
          icon: '',
          text: 'Company Submission',
          link: '/admin/settings/requests',
          query: {
            page: 'companies'
          }
        } // {
        //   icon: '',
        //   text: 'Group Post',
        //   link: '/admin/settings/requests',
        //   query: {
        //     page: 'groups'
        //   }
        // },
        // {
        //   icon: '',
        //   text: 'Group Events',
        //   link: '/admin/settings/requests',
        //   query: {
        //     page: 'group-events'
        //   }
        // }
        ]
      }, {
        icon: '',
        text: 'Feedback/Support',
        link: '/admin/settings/support',
        children: [{
          text: 'Feedback',
          link: '/admin/settings/support',
          query: {
            page: 'feedback'
          }
        }, {
          text: 'Help Requests',
          link: '/admin/settings/support',
          query: {
            page: 'help-requests'
          }
        }]
      }, {
        icon: '',
        text: 'Admin Tutorials',
        link: '/admin/settings/tutorials',
        children: [{
          text: 'All Tutorials',
          link: '/admin/settings/tutorials',
          query: {
            page: 'all'
          }
        }, {
          text: 'Manage Tutorials',
          link: '/admin/settings/tutorials',
          query: {
            page: 'manage'
          }
        }]
      }]
    };
  },
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    }
  },
  methods: {
    checkUserRole: function checkUserRole() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var usr, fb, user, alert;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                usr = _this.$store.getters.getUserDetails;
                fb = _this.$firebase.database().ref();
                _context.next = 4;
                return fb.child('users/' + usr.uid.toString()).once('value');

              case 4:
                user = _context.sent;

                if (user.role !== 1) {
                  alert = {
                    ative: true,
                    header: 'Access denied',
                    text: "You don't have access on this page",
                    okText: 'Ok',
                    cancelText: ''
                  };

                  _this.$store.dispatch('triggerAlert', alert);

                  _this.$router.push('/user/feed');
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    isOpen: function isOpen(rootPath) {
      return this.$route.fullPath.indexOf(rootPath) > -1;
    }
  }
};

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".sidebar-menu[data-v-060504ef]{top:55px}.list__tile--active[data-v-060504ef],.list__tile--active[data-v-060504ef]:hover{background-color:rgba(0,0,0,.1)!important}.menu_list_data[data-v-060504ef]{width:100%}.menu_list_data li[data-v-060504ef]{margin-bottom:12px;padding-right:20px}.menu_list_item_data[data-v-060504ef]{font-size:16px}.list__group i[data-v-060504ef],.list__tile i[data-v-060504ef]{color:#a2a2a2}.list__tile__action[data-v-060504ef]{min-width:30px}.list__group__header--active[data-v-060504ef],.list__group__items[data-v-060504ef]{background-color:rgba(0,0,0,.4)}.list[data-v-060504ef]{background:transparent!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Components/AdminSideBar.vue"],"names":[],"mappings":"AACA,+BACE,QAAU,CACX,AAID,gFACE,yCAAgD,CACjD,AACD,iCACE,UAAY,CACb,AACD,oCACE,mBAAoB,AACpB,kBAAoB,CACrB,AACD,sCACE,cAAgB,CACjB,AACD,+DACE,aAAe,CAChB,AACD,qCACE,cAAgB,CACjB,AAID,mFACE,+BAAqC,CACtC,AACD,uBACE,gCAAmC,CACpC","file":"AdminSideBar.vue","sourcesContent":["\n.sidebar-menu[data-v-060504ef] {\n  top: 55px;\n}\n.list__tile--active[data-v-060504ef] {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n.list__tile--active[data-v-060504ef]:hover {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n.menu_list_data[data-v-060504ef] {\n  width: 100%;\n}\n.menu_list_data li[data-v-060504ef] {\n  margin-bottom: 12px;\n  padding-right: 20px;\n}\n.menu_list_item_data[data-v-060504ef] {\n  font-size: 16px;\n}\n.list__group i[data-v-060504ef], .list__tile i[data-v-060504ef] {\n  color: #a2a2a2;\n}\n.list__tile__action[data-v-060504ef] {\n  min-width: 30px;\n}\n.list__group__items[data-v-060504ef] {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.list__group__header--active[data-v-060504ef] {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.list[data-v-060504ef] {\n  background: transparent !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(843);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("91f344b8", content, true, {});

/***/ }),

/***/ 846:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    staticClass: "sidebar-menu",
    style: ({
      backgroundColor: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "dark": "",
      "fixed": "",
      "value": true,
      "mobile-break-point": 768,
      "clipped": true
    }
  }, [_c('v-list', {
    staticClass: "menu_list_data",
    attrs: {
      "dark": ""
    }
  }, _vm._l((_vm.items), function(item, i) {
    return (item.children) ? _c('v-list-group', {
      key: i,
      attrs: {
        "value": _vm.isOpen(item.link)
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator",
        "color": "grey"
      },
      slot: "activator"
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "menu_list_item_data",
      attrs: {
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "white--text menu_list_item_data"
    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])], 1)], 1), _vm._v(" "), _vm._l((item.children), function(sub_item, i) {
      return _c('v-list-tile', {
        key: i,
        attrs: {
          "router": "",
          "to": sub_item.query ? ((sub_item.link) + "/" + (sub_item.query.page)) : ("" + (sub_item.link))
        }
      }, [_c('v-list-tile-action', [_c('v-icon', {
        staticClass: "menu_list_item_data",
        attrs: {
          "color": "white"
        }
      }, [_vm._v(_vm._s(sub_item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
        staticClass: "white--text menu_list_item_data"
      }, [_vm._v("\n            " + _vm._s(sub_item.text) + "\n          ")])], 1)], 1)
    })], 2) : _c('v-list-tile', {
      attrs: {
        "router": "",
        "to": item.link
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "menu_list_item_data",
      attrs: {
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "white--text menu_list_item_data"
    }, [_vm._v("\n          " + _vm._s(item.text) + "\n        ")])], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".page-footer[data-v-1c309d0c]{position:absolute;height:50px;right:0;bottom:0;left:300px;background:#f9f9fa;border-top:1px solid #e1e6ef;text-align:center;line-height:50px;color:#151b1e}.page-footer p[data-v-1c309d0c]{margin:0}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Components/PageFooter.vue"],"names":[],"mappings":"AACA,8BACE,kBAAmB,AACnB,YAAa,AACb,QAAS,AACT,SAAU,AACV,WAAY,AACZ,mBAAoB,AACpB,6BAA8B,AAC9B,kBAAmB,AACnB,iBAAkB,AAClB,aAAe,CAChB,AACD,gCACI,QAAU,CACb","file":"PageFooter.vue","sourcesContent":["\n.page-footer[data-v-1c309d0c] {\n  position: absolute;\n  height: 50px;\n  right: 0;\n  bottom: 0;\n  left: 300px;\n  background: #f9f9fa;\n  border-top: 1px solid #e1e6ef;\n  text-align: center;\n  line-height: 50px;\n  color: #151b1e;\n}\n.page-footer p[data-v-1c309d0c] {\n    margin: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(871);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("2eac6325", content, true, {});

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(873)
}
var Component = __webpack_require__(14)(
  /* script */
  null,
  /* template */
  __webpack_require__(877),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c309d0c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 877:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-footer mt-4"
  }, [_c('p', [_vm._v("Georgia Defense-Exchange")])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.25c04af0ddd72ecef928.js